export default __webpack_public_path__ + "static/media/profile.1172d0d9.svg";